<template>
  <div>
    <g-master name="evaluaciones"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
              @action="masterAction"
              ref="masterComponent"
    >
      <template slot="progresoSlot" slot-scope="{text, record}">
        <a-progress :percent="parseInt(record.porcentaje)" status="active"/>
      </template>
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <a-col v-bind="colOptions">
              <g-lookup :label="$t('Evaluador')"
                        :formItemConfig="fiOptions"
                        endpoint="empleados"
                        :params="{estado_activo: true}"
                        :decorator="['id_evaluator', { rules: [{ required: true, message: 'Valor requerido' }] }]"
              >
              </g-lookup>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="forms"
                          :label="$t('Tipo de evaluación')"
                          :decorator="['id_form', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :formItemConfig="fiOptions"
                          :params="{requisiciones: true}">
              </g-dropdown>
            </a-col>
          </a-col>
        </a-row>
      </template>
    </g-master>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import UserUtil from '@/util/UserUtil'
  import Mensajes from '@/util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        pageTitle: 'Evaluaciones',
        visible: false,
        nombre: '',
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          endpoint: 'person_requisition_evaluator',
          tableSetup: {
            actions: {
              width: 180,
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  icon: 'edit',
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return this.isHRReq
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  icon: 'delete',
                  props: {size: 'small', type: 'link', icon: 'delete', style: 'color:red;'},
                  fnVisible: (record) => {
                    return this.isHRReq && parseFloat(record.porcentaje) === 0
                  }
                },
                {
                  name: 'clear_fills',
                  text: 'Vaciar formulario',
                  props: {size: 'small', type: 'link', icon: 'close-square', style: 'color:red;'},
                  fnVisible: (record) => {
                    return this.isHRReq && parseFloat(record.porcentaje) > 0
                  }
                }
              ]
            },
            customSlots: ['progresoSlot'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID Evaluador', dataIndex: 'id_evaluator', sorter: true},
              {title: 'Nombre evaluador', dataIndex: 'nombre_evaluador', sorter: true},
              {title: 'Tipo evaluación', dataIndex: 'tipo_evaluacion', sorter: true},
              {
                title: 'Porcentaje calificación',
                dataIndex: 'porcentaje',
                sorter: true,
                scopedSlots: {customRender: 'progresoSlot', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
              },
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_evaluator'},
            {name: 'id_form'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'clear_fills':
            if (action.record.hasOwnProperty('id_forms_fillout')) {
              if (action.record.id_forms_fillout != -1) {
                this.$confirm({
                  title: 'Confirmación',
                  content: '¿Está seguro que desea elminar los formularios?',
                  okText: 'Si',
                  okType: 'danger',
                  cancelText: 'No',
                  onOk: () => {
                    return new Promise((resolve, reject) => {
                      this.httpClient.getInstance().delete('gestion_humana/requisiciones/clear_fillouts/' + action.record.id_forms_fillout)
                        .then((response) => {
                          Mensajes.success('Correcto', 'Proceso realizado exitosamente.')
                          this.$refs.masterComponent.$refs.datatable.loadData() // cambio
                          resolve()
                        })
                        .catch((error) => {
                          Mensajes.error('Error', 'No fue posible realizar la solicitud.')
                          reject(error)
                        })
                    })
                  },
                  onCancel () {}
                })
              }
            } else {
              Mensajes.error('Error', 'No fue posible realizar la solicitud porque este elemento aún no tiene un formulario asociado.')
            }

            break
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_person_reg: this.id_person_reg
        }
      },
      isHRReq () {
        return this.$userIsInrol('HRReq')
      }
    },
    props: ['id_person_reg']
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Requisiciones/PersonRequisitionEvaluator.vue